import { XhtmlComponentRenderer } from "@/components/xhtml/component-renderer";
import type { XHtmlProps } from "@/components/xhtml/types";
import DOMPurify from "dompurify";
import type { ReactNode } from "react";

export function XHtml({ xhtmlString }: XHtmlProps) {
	const parseHTML = (html: string): HTMLElement | null => {
		const sanitizedHTML = DOMPurify.sanitize(html);
		const parser = new DOMParser();
		const doc = parser.parseFromString(sanitizedHTML, "text/html");
		return doc.body;
	};

	const renderNode = (node: Node): ReactNode => {
		if (node.nodeType === Node.TEXT_NODE) return node.textContent;

		if (node.nodeType === Node.ELEMENT_NODE) {
			const element = node as HTMLElement;
			const tagName = element.tagName.toLowerCase();
			const attributes = Array.from(element.attributes).reduce(
				(acc, attr) => {
					acc[attr.name] = attr.value;
					return acc;
				},
				{} as Record<string, string>,
			);

			const children = Array.from(element.childNodes).map((childNode, index) =>
				renderNode(childNode),
			);

			return XhtmlComponentRenderer({
				tagName,
				attributes,
				children,
			});
		}

		return null;
	};

	const htmlRoot = parseHTML(xhtmlString);

	return (
		<>{htmlRoot ? Array.from(htmlRoot.childNodes).map(renderNode) : null}</>
	);
}
